<script lang="ts" module>
	import type { ISbStoryData } from '@storyblok/js';
	import type { SbImage } from '../types';
	import Image from '../components/image.svelte';

	export interface BenefitsBoxItem {
		name: string;
		icon: SbImage;
	}
</script>

<script lang="ts">
	interface Props {
		content: ISbStoryData<BenefitsBoxItem>['content'];
	}

	let { content }: Props = $props();
</script>

<div class="flex items-center gap-x-2">
	<Image src={content.icon.filename} class="h-6 w-6" />
	<span class="text-[14px]/[160%] text-brown-1">{content.name}</span>
</div>
